module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h3', {
    staticClass: "text-center"
  }, [_vm._v("Add/Remove Groups")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.groupSearchText),
      expression: "groupSearchText"
    }],
    staticClass: "form-control input-lg",
    attrs: {
      "type": "text",
      "placeholder": "Search for groups to add"
    },
    domProps: {
      "value": (_vm.groupSearchText)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.groupSearchText = $event.target.value
      }, function($event) {
        return _vm.getAvailableGroups()
      }]
    }
  })]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }]
  }, [_c('div', {
    staticClass: "row content-centered",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    staticClass: "box box-info box-solid"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedAvailableGroups),
      expression: "selectedAvailableGroups"
    }],
    ref: "availablelist",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "multiple": "",
      "size": "10"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedAvailableGroups = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.selectedUserGroups = []
      }]
    }
  }, _vm._l((_vm.availableGroups), function(obj) {
    return _c('option', {
      domProps: {
        "value": obj
      }
    }, [_vm._v("\n                " + _vm._s((obj.group || {}).name) + "\n              ")])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 content-centered"
  }, [_c('div', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.addGroups()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-right fa-3x icon-btn icon-btn-primary"
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        return _vm.removeGroups()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-left fa-3x icon-btn icon-btn-info"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    staticClass: "box box-primary box-solid"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedUserGroups),
      expression: "selectedUserGroups"
    }],
    ref: "userlist",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "multiple": "",
      "size": "10"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedUserGroups = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.selectedAvailableGroups = []
      }]
    }
  }, _vm._l((_vm.newUser.groups), function(obj) {
    return _c('option', {
      domProps: {
        "value": obj
      }
    }, [_vm._v("\n                " + _vm._s(obj.group.name) + "\n              ")])
  }), 0)])])])]), _vm._v(" "), _c('div', [_c('input', {
    staticClass: "form-control",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "disabled": true,
      "placeholder": _vm.groupDescription
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newUser._id),
      expression: "newUser._id"
    }],
    staticClass: "py-2 text-center row",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('button', {
    directives: [{
      name: "permission",
      rawName: "v-permission.enable",
      value: (['user', 'addUserGroups', 'removeUserGroups',
        'addUserAssociations', 'removeUserAssociations'
      ]),
      expression: "['user', 'addUserGroups', 'removeUserGroups',\n              'addUserAssociations', 'removeUserAssociations']",
      modifiers: {
        "enable": true
      }
    }],
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "disabled": !_vm.dirty
    },
    on: {
      "click": _vm.updateUserGroups
    }
  }, [_vm._v("Update User Groups")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Available Groups")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Current Groups")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c5d1936"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/users/UserGroups.vue
// module id = 2326
// module chunks = 1